/**
 * Client-side wrapper for the shared festival clock.
 *
 * Holds the festival epoch (received from the server in the Welcome message)
 * and exposes `now()` to anything that needs the current sim time.
 */

import {
  festivalTimeFromEpoch,
  type FestivalTime
} from '@shared/festival-clock';

export class FestivalClock {
  private epochMs: number = Date.now();

  setEpoch(epochMs: number): void {
    this.epochMs = epochMs;
  }

  now(): FestivalTime {
    return festivalTimeFromEpoch(this.epochMs);
  }
}

export const festivalClock = new FestivalClock();
